module.exports = __webpack_public_path__ + "img/bakery_bodyimage09.d1b72af6.jpg";